// src/pages/ServicePartnerViewPage.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Heading, Text, VStack, Button } from "@chakra-ui/react";
import axios from "axios";

export default function ServicePartnerViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/service-partner/${id}`)
      .then((res) => setPartner(res.data))
      .catch((err) =>
        console.error("Fehler beim Laden des Service Partners:", err)
      );
  }, [id]);

  if (!partner) return <Text>Lade Service Partner Daten...</Text>;

  return (
    <Box
      maxW="2xl"
      mx="auto"
      mt={10}
      p={8}
      bg="white"
      borderRadius="xl"
      boxShadow="lg"
    >
      <Heading size="md" mb={6}>
        Service Partner Details
      </Heading>

      <VStack align="stretch" spacing={3}>
        <Detail label="Firmenname" value={partner.firmenName} />
        <Detail label="Partnername" value={partner.partnerName} />
        <Detail label="E-Mail" value={partner.email} />
        <Detail label="Telefon" value={partner.telefon} />
        <Detail label="Mobil-Nr." value={partner.mobilNr} />
        <Detail label="Straße / Hausnummer" value={partner.strasseHausnummer} />
        <Detail label="PLZ" value={partner.plz} />
        <Detail label="Ort" value={partner.ort} />
      </VStack>

      <Button mt={6} colorScheme="blue" onClick={() => navigate(-1)}>
        Zurück
      </Button>
    </Box>
  );
}

function Detail({ label, value }) {
  return (
    <Text>
      <Text as="span" fontWeight="semibold">
        {label}:
      </Text>{" "}
      {value || "-"}
    </Text>
  );
}